import React from 'react';
import { IconProps } from '.';

const SvgCounselor = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M12 3.75A6.25 6.25 0 0 0 5.75 10v5H2.5v-5h1.75a7.75 7.75 0 1 1 15.5 0h1.75v5h-1.824a6.758 6.758 0 0 1-4.752 5.472 1.5 1.5 0 1 1-.309-1.475A5.252 5.252 0 0 0 18.25 14v-4A6.25 6.25 0 0 0 12 3.75Z'
      />
      <path
        fill={color}
        d='M9.5 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM14.5 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM13.5 13a1.5 1.5 0 0 1-3 0h-1a2.5 2.5 0 0 0 5 0h-1Z'
      />
    </svg>
  );
};

export default SvgCounselor;
